import { render, staticRenderFns } from "./SeamlessKey.vue?vue&type=template&id=66d57e3c&scoped=true&"
import script from "./SeamlessKey.vue?vue&type=script&lang=ts&"
export * from "./SeamlessKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d57e3c",
  null
  
)

export default component.exports